import React from 'react';
import '../stylesheets/App.scss';
import CNNHeader from './CNNHeader';
import A from './A';
import B from './B';
import C from './C';
import D from './D';
import E from './E';
import F from './F';
import G from './G';
import Intro from './Intro';
import ArticleLinks from './ArticleLinks';

function App() {
  // const url = 'http://localhost:3000/';
  // const url = 'http://courageous-john-hancock-staging.s3-website-us-east-1.amazonaws.com/';
  const url = 'http://sponsorcontent.cnn.com/interactive/john-hancock/';

  const location = window.location.href.endsWith('/') ? window.location.href.substring(0, window.location.href.length - 1) : window.location.href;

  const locationSplit = location.split('/');
  const firstArticleId = locationSplit.includes('interactive') ? locationSplit[5] : locationSplit[3];
  return (
    <>
      <CNNHeader />
      <Intro />

      {firstArticleId === 'psychology-of-wealth' && <A />}
      {firstArticleId === 'pie-in-the-sky' && <B stagingUrl={url} />}
      {firstArticleId === 'wild-in-alaska' && <C stagingUrl={url} />}
      {firstArticleId === 'generations-of-wealth' && <D />}
      {firstArticleId === 'the-wealth-diaries' && <E />}
      {firstArticleId === 'saving-the-maah-daah-hey' && <F stagingUrl={url} />}
      {firstArticleId === 'calm-after-crisis' && <G stagingUrl={url} />}

      <ArticleLinks stagingUrl={url} />
    </>
  );
}

export default App;
